import {
  ES_DASHBOARD_STATS_LOADING,
  ES_DASHBOARD_STATS_SUCCESS,
  ES_DASHBOARD_STATS_ERROR,
  ES_PATHOGEN_BREAKDOWN_LOADING,
  ES_PATHOGEN_BREAKDOWN_SUCCESS,
  ES_PATHOGEN_BREAKDOWN_ERROR,
  ES_DETECTION_RATE_LOADING,
  ES_DETECTION_RATE_SUCCESS,
  ES_DETECTION_RATE_ERROR,
  ES_SITE_MAP_LOADING,
  ES_SITE_MAP_SUCCESS,
  ES_SITE_MAP_ERROR,
  ES_TIMELINESS_LOADING,
  ES_TIMELINESS_SUCCESS,
  ES_TIMELINESS_ERROR,
  ES_DASHBOARD_RESET,
} from "constants/ActionTypes";

const INITIAL_STATE = {
  // Dashboard Stats
  statsLoading: false,
  statsData: null,
  statsError: null,

  // Pathogen Breakdown
  pathogenLoading: false,
  pathogenData: null,
  pathogenError: null,

  // Detection Rate
  detectionLoading: false,
  detectionData: null,
  detectionError: null,

  // Site Map
  siteMapLoading: false,
  siteMapData: null,
  siteMapError: null,

  // Timeliness
  timelinessLoading: false,
  timelinessData: null,
  timelinessError: null,
};

const esDashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --- Stats ---
    case ES_DASHBOARD_STATS_LOADING:
      return { ...state, statsLoading: true, statsError: null };
    case ES_DASHBOARD_STATS_SUCCESS:
      return { ...state, statsLoading: false, statsData: action.payload };
    case ES_DASHBOARD_STATS_ERROR:
      return { ...state, statsLoading: false, statsError: action.payload };

    // --- Pathogen Breakdown ---
    case ES_PATHOGEN_BREAKDOWN_LOADING:
      return { ...state, pathogenLoading: true, pathogenError: null };
    case ES_PATHOGEN_BREAKDOWN_SUCCESS:
      return { ...state, pathogenLoading: false, pathogenData: action.payload };
    case ES_PATHOGEN_BREAKDOWN_ERROR:
      return { ...state, pathogenLoading: false, pathogenError: action.payload };

    // --- Detection Rate ---
    case ES_DETECTION_RATE_LOADING:
      return { ...state, detectionLoading: true, detectionError: null };
    case ES_DETECTION_RATE_SUCCESS:
      return { ...state, detectionLoading: false, detectionData: action.payload };
    case ES_DETECTION_RATE_ERROR:
      return { ...state, detectionLoading: false, detectionError: action.payload };

    // --- Site Map ---
    case ES_SITE_MAP_LOADING:
      return { ...state, siteMapLoading: true, siteMapError: null };
    case ES_SITE_MAP_SUCCESS:
      return { ...state, siteMapLoading: false, siteMapData: action.payload };
    case ES_SITE_MAP_ERROR:
      return { ...state, siteMapLoading: false, siteMapError: action.payload };

    // --- Timeliness ---
    case ES_TIMELINESS_LOADING:
      return { ...state, timelinessLoading: true, timelinessError: null };
    case ES_TIMELINESS_SUCCESS:
      return { ...state, timelinessLoading: false, timelinessData: action.payload };
    case ES_TIMELINESS_ERROR:
      return { ...state, timelinessLoading: false, timelinessError: action.payload };

    // --- Reset ---
    case ES_DASHBOARD_RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default esDashboardReducer;